import {View, StyleSheet, Image} from 'react-native';
import React from 'react';
import UICircularProgress from '../circular-progress/Asl';
import {white, isWeb} from '../../utils/utils';
export const Progressbar = props => {
   const {
      size = 22,
      width = 16,
      progress,
      status,
      imgWidth = 18,
      imgHeight = 18,
   } = props;

   const icon = status
      ? require('../../assets/asl-pause-icon.png')
      : require('../../assets/asl-play-icon.png');
   //const imgTintClr = white;
   const imgTintClr = status ? (isWeb ? '#CCC' : null) : white;
   return (
      <View style={style.proContainer}>
         <UICircularProgress
            size={size}
            width={width}
            fill={progress}
            rotation={0}
            bgOpacity={1}
            tintColor={'#00F'}
            background={true}
            backgroundColor={'transparent'}
            trailStroke={'#7d7979'}
            //trailStroke={'transparent'}
            img={icon}
            imgWidth={imgWidth}
            imgHeight={imgHeight}
            noImgTintClr={true}
            showPercent={false}
            percentFont={30}
            shadowColor={'grey'}
         />
      </View>
   );
};
export const MediaIcon = () => {
   return (
      <View style={style.proContainer}>
         <Image
            source={require('../../assets/asl-play-icon.png')}
            tintColor={white}
            style={{
               height: 22,
               width: 22,
               borderRadius: 10,
               tintColor: white,
               //left: 1,
               resizeMode: 'contain',
            }}
         />
      </View>
   );
};
const style = StyleSheet.create({
   proContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      maxHeight: 22,
      maxWidth: 22,
      backgroundColor: 'transparent',
   },
});
export default Progressbar;
